import React, { Component } from "react";
import { connect } from "react-redux";
import { Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { ACTION_TYPE } from "reducers/actionType";
import AdditionalSubjectsList from "components/atar/AdditionalSubjectsList";
import NotFound from "components/attribute/NotFound";
import { selectFilter } from "utils/helpers";
import MasterButton, { BUTTON_TYPES } from "components/ui/MasterButton";
import { NavLink } from "react-router-dom";

class AddMoreSubjects extends Component {
  state = {
    search: false,
  };

  handleSearch = (value) => {
    this.setState({ search: true }, () => {
      document.addEventListener("click", this.closeSelect);
    });
  };

  closeSelect = (event) => {
    this.setState({ search: false }, () => {
      document.removeEventListener("click", this.closeSelect);
    });
  };

  handleChange = (selectedValues) => {
    this.props.dispatch({
      type: ACTION_TYPE.pickAddSubs,
      data: { userAddSubs: selectedValues },
    });
    this.setState({ search: false });
  };

  handleToggleSubject = (idNum) => {
    const newId = idNum.toString();
    const newSelectedItems = Array.from(this.props.userAddSubs);
    if (newSelectedItems.find((id) => newId === id) > -1) {
      newSelectedItems.splice(newSelectedItems.indexOf(newId), 1);
    } else {
      newSelectedItems.push(newId);
    }
    this.handleChange(newSelectedItems);
  };

  render() {
    const { subjects } = this.props.input;
    const { userAddSubs, additionalSubjects, otherSubjects } = this.props;

    const options = otherSubjects.concat(additionalSubjects).map((key) => {
      const name = subjects[key].name;
      return (
        <Select.Option key={key} value={key}>
          {name}
        </Select.Option>
      );
    });

    return (
      <div className="margin-top">
        <div className="add-more-subjects padding-sides">
          <NavLink to="/summary/all-subjects" className="mobile-only">
            <MasterButton
              type={BUTTON_TYPES.TERTIARY}
              text="View All Subjects"
              wide={true}
              style={{ marginBottom: 20 }}
            />
          </NavLink>

          <div className="flex-space-between">
            <h1>Add subjects</h1>

            <NavLink to="/summary/all-subjects" className="desktop-and-tablet">
              <MasterButton
                type={BUTTON_TYPES.TERTIARY}
                text="View All Subjects"
              />
            </NavLink>
          </div>

          <label
            className="title"
            htmlFor="Select Subjects"
            id="Select Subjects Label"
          >
            Subject name
          </label>
          <Select
            id="Select Subjects"
            bordered={false}
            onFocus={this.props.handleFocusSelect}
            onBlur={this.props.handleBlurSelect}
            filterOption={selectFilter}
            className="search-blue-underline margin-top"
            mode="multiple"
            value={userAddSubs}
            style={{ marginTop: 20, marginBottom: 20, width: "100%" }}
            placeholder={
              <div className="flex-space-between">
                <p>eg Russian, Hospitality</p>
                <SearchOutlined />
              </div>
            }
            onChange={this.handleChange}
            open={this.state.search}
            onSearch={this.handleSearch}
            notFoundContent={
              <NotFound
                heading="Subject not found"
                buttonText="our list of subjects"
                navlink="/summary/all-subjects"
              />
            }
          >
            {options}
          </Select>
        </div>

        {userAddSubs && userAddSubs.length > 0 && (
          <AdditionalSubjectsList
            list={userAddSubs}
            handleToggleSubject={this.handleToggleSubject}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { input } = store.inputReducer;
  const { recommendations } = store.recommendationsReducer;

  const { additionalSubjects } = store.additionalSubjectsReducer;
  const { otherSubjects } = store.otherSubjectsReducer;
  const { userAddSubs } = store.pickAddSubReducer;
  const { userOthSubs } = store.pickOthSubReducer;
  return {
    input,
    recommendations,
    additionalSubjects,
    otherSubjects,
    userAddSubs,
    userOthSubs,
  };
};
export default connect(mapStateToProps)(AddMoreSubjects);
